import { type ReactElement } from 'react';
import { CatalogId } from '@kirin/api-client/contracts/ai-instruction-catalog';
import { CatalogModePage, type CatalogModePageProps } from './CatalogModePage';

type ThreatModelingPageProps = Omit<CatalogModePageProps, 'catalog'>;

/**
 * KIR-3925: the Threat Modeling page (AI AppSec) — the Threat Modeling Best
 * Practices + Custom / Proprietary catalog whose mode drives the scanner-less
 * `threat-modeling` policy. Thin call site over {@link CatalogModePage}.
 */
export function ThreatModelingPage(
  props: ThreatModelingPageProps
): ReactElement {
  return <CatalogModePage catalog={CatalogId.ThreatModeling} {...props} />;
}
